'use client'
import Image from "next/image";
import { useState } from "react";
import { FaPlay } from "react-icons/fa6";
const YoutubePreview = ({ height = '400', width = '1000', url, title, isMobile = false }) => {
  const [showVideo, setShowVideo] = useState(false);

    const videoId = url.split('/').at(-1)

  const thumbnail = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;

    return (
        <>
            {!showVideo ? (
                <div className="relative w-full aspect-video" onClick={() => setShowVideo(true)}>
                    <Image
                        src={thumbnail}
                        fill
                        alt="Video thumbnail"
                        style={{ objectFit: "cover" }}
                        priority={true}
                    />
                    <div className="absolute inset-0 flex items-center justify-center text-white">
                        <div className="flex inset-0 justify-center items-center rounded-md bg-third w-[80px] h-[50px] cursor-pointer">
                            <FaPlay size={32} />
                        </div>
                    </div>
                </div>
            ) : (
                <iframe
                    width={width}
                    height={height}
                    src={`${url}?autoplay=1`}
                    title="Property Video"
                    frameorder="0"
                    allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay;"
                    allowFullScreen={isMobile ? false : true}
                />
            )}
        </>
    )
}

export default YoutubePreview